import type { GetApprovalAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetApprovalAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetApprovalAuditByIdArgs = {
  id: string;
};

export const useGetApprovalAuditById = createQueryHook<
  UseGetApprovalAuditByIdArgs,
  GetApprovalAuditByIdQuery['approval_audit'],
  GetApprovalAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getApprovalAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ approval_audit: data }),
  graphqlDocument: GetApprovalAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
